import React from 'react';
import { Mic, MicOff, Loader2 } from 'lucide-react';

interface Props {
  status: 'idle' | 'connecting' | 'connected' | 'disconnected' | 'error';
  onStart: () => void;
  onStop: () => void;
}

const STATUS_LABELS: Record<string, string> = {
  idle: 'Start Session',
  connecting: 'Connecting...',
  connected: 'End Session',
  disconnected: 'Start Session',
  error: 'Retry',
};

export const TutorControls: React.FC<Props> = ({ status, onStart, onStop }) => {
  const isActive = status === 'connected';
  const isLoading = status === 'connecting';

  return (
    <div className="flex flex-col items-center gap-4">
      <button
        onClick={isActive ? onStop : onStart}
        disabled={isLoading}
        className={`flex items-center gap-3 px-8 py-4 rounded-2xl text-lg font-semibold transition-all ${
          isActive
            ? 'bg-[#FF453A]/20 text-[#FF453A] border border-[#FF453A]/30 hover:bg-[#FF453A]/30'
            : 'bg-[#30D158]/20 text-[#30D158] border border-[#30D158]/30 hover:bg-[#30D158]/30'
        } disabled:opacity-50`}
      >
        {isLoading ? (
          <Loader2 className="w-6 h-6 animate-spin" />
        ) : isActive ? (
          <MicOff className="w-6 h-6" />
        ) : (
          <Mic className="w-6 h-6" />
        )}
        {STATUS_LABELS[status]}
      </button>
      {status === 'error' && (
        <p className="text-[#FF453A] text-sm">Connection error. Please try again.</p>
      )}
    </div>
  );
};
